import { Center, Flex, rem, Text, UnstyledButton } from '@mantine/core'
import {
    IconChevronDown,
    IconChevronUp,
    IconSelector,
} from '@tabler/icons-react'
import React from 'react'

// const useStyles = createStyles((theme) => ({
//     th: {
//         padding: '0 !important',
//     },

//     control: {
//         width: '100%',
//     },

//     icon: {
//         width: rem(21),
//         height: rem(21),
//         borderRadius: rem(21),
//     },
// }))

interface ThProps {
    label: string
    width: string
    reversed?: boolean
    sorted?: boolean
    onSort?(): void
}

const TableHeaderColumn = ({
    label,
    width,
    reversed,
    sorted,
    onSort,
}: ThProps) => {
    const Icon = sorted
        ? reversed
            ? IconChevronUp
            : IconChevronDown
        : IconSelector
    // const { classes } = useStyles()

    if (onSort && sorted !== undefined && reversed !== undefined) {
        return (
            <th
                style={{
                    overflow: 'hidden',
                    width: width,
                    whiteSpace: 'nowrap',
                    wordBreak: 'keep-all',
                }}
            >
                <UnstyledButton onClick={onSort} w='100%'>
                    <Flex>
                        <Text size='sm' fw={500} mr='auto'>
                            {label}
                        </Text>
                        <Center
                            w={rem(21)}
                            h={rem(21)}
                            style={{ borderRadius: rem(21) }}
                        >
                            <Icon size='0.9rem' stroke={1.5} />
                        </Center>
                    </Flex>
                </UnstyledButton>
            </th>
        )
    } else {
        return (
            <th
                style={{
                    overflow: 'hidden',
                    width: width,
                    whiteSpace: 'nowrap',
                    wordBreak: 'keep-all',
                }}
            >
                <Text size='sm' fw={500} ta='left'>
                    {label}
                </Text>
            </th>
        )
    }
}

export default TableHeaderColumn
